import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../../atoms/button';
import { Color } from '../../enums/color';
import { ModalType } from './enum';
import * as styles from './modal.module.sass';
import { ModalProps } from './props.type';

const Modal = (props: ModalProps) => {
  const { type = ModalType.SIDE, children, onBackdropClick, onCloseClick, buttonClassName } = props;

  const [active, setActive] = useState(false);

  const windowKeyDownHandler = (event: KeyboardEvent) => {
    if (event.code === 'Escape') {
      props.onCloseClick?.();
    }
  };

  useEffect(() => {
    setTimeout(() => setActive(true), 10);
    window.addEventListener('keydown', windowKeyDownHandler);
    document.body.classList.add(styles.body);

    return () => {
      window.removeEventListener('keydown', windowKeyDownHandler);
      document.body.classList.remove(styles.body);
    };
  }, []);

  return (
    <>
      <div className={styles.backdrop} tabIndex={-1} role="dialog" aria-modal="true" onClick={onBackdropClick} />
      <div className={classNames(styles.modal, styles[type], { [styles.active]: active })}>
        <Button
          onClick={onCloseClick}
          color={Color.EMPTYALL}
          className={classNames(styles.close_button, buttonClassName)}
        />

        <div className={classNames(styles.content)}>{children}</div>
      </div>
    </>
  );
};

export const ModalContent = (props: ModalProps) => {
  return <>{createPortal(<Modal {...props} />, document.body)}</>;
};
